// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { getConfig, getMe, getMeState, getMeWallet, getParamByIds, getRewardsRecentWinners, type Options, postMeOpenMilestonesByMilestoneId, postTimesync } from '../sdk.gen';
import type { GetConfigData, GetConfigResponse, GetMeData, GetMeResponse, GetMeStateData, GetMeStateResponse, GetMeWalletData, GetMeWalletResponse, GetParamByIdsData, GetParamByIdsResponse, GetRewardsRecentWinnersData, GetRewardsRecentWinnersResponse, PostMeOpenMilestonesByMilestoneIdData, PostMeOpenMilestonesByMilestoneIdResponse, PostTimesyncData, PostTimesyncResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getParamByIdsQueryKey = (options: Options<GetParamByIdsData>) => createQueryKey('getParamByIds', options);

/**
 * Common params
 */
export const getParamByIdsOptions = (options: Options<GetParamByIdsData>) => queryOptions<GetParamByIdsResponse, DefaultError, GetParamByIdsResponse, ReturnType<typeof getParamByIdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getParamByIds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getParamByIdsQueryKey(options)
});

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, DefaultError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const getMeStateQueryKey = (options?: Options<GetMeStateData>) => createQueryKey('getMeState', options);

/**
 * getState
 *
 * Get user current state. Including: owned items, openned milestone, rewards.
 */
export const getMeStateOptions = (options?: Options<GetMeStateData>) => queryOptions<GetMeStateResponse, DefaultError, GetMeStateResponse, ReturnType<typeof getMeStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeStateQueryKey(options)
});

export const getMeWalletQueryKey = (options?: Options<GetMeWalletData>) => createQueryKey('getMeWallet', options);

/**
 * getWallet
 *
 * Get the current cached Gem balance.
 */
export const getMeWalletOptions = (options?: Options<GetMeWalletData>) => queryOptions<GetMeWalletResponse, DefaultError, GetMeWalletResponse, ReturnType<typeof getMeWalletQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeWallet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeWalletQueryKey(options)
});

/**
 * openMilestone
 *
 * Open the milestone
 */
export const postMeOpenMilestonesByMilestoneIdMutation = (options?: Partial<Options<PostMeOpenMilestonesByMilestoneIdData>>): UseMutationOptions<PostMeOpenMilestonesByMilestoneIdResponse, DefaultError, Options<PostMeOpenMilestonesByMilestoneIdData>> => {
    const mutationOptions: UseMutationOptions<PostMeOpenMilestonesByMilestoneIdResponse, DefaultError, Options<PostMeOpenMilestonesByMilestoneIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMeOpenMilestonesByMilestoneId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postTimesyncMutation = (options?: Partial<Options<PostTimesyncData>>): UseMutationOptions<PostTimesyncResponse, DefaultError, Options<PostTimesyncData>> => {
    const mutationOptions: UseMutationOptions<PostTimesyncResponse, DefaultError, Options<PostTimesyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTimesync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConfigQueryKey = (options?: Options<GetConfigData>) => createQueryKey('getConfig', options);

export const getConfigOptions = (options?: Options<GetConfigData>) => queryOptions<GetConfigResponse, DefaultError, GetConfigResponse, ReturnType<typeof getConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConfigQueryKey(options)
});

export const getRewardsRecentWinnersQueryKey = (options?: Options<GetRewardsRecentWinnersData>) => createQueryKey('getRewardsRecentWinners', options);

/**
 * getRecentWinners
 *
 * Get the latest grand-prize winners for the event marquee.
 */
export const getRewardsRecentWinnersOptions = (options?: Options<GetRewardsRecentWinnersData>) => queryOptions<GetRewardsRecentWinnersResponse, DefaultError, GetRewardsRecentWinnersResponse, ReturnType<typeof getRewardsRecentWinnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRewardsRecentWinners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRewardsRecentWinnersQueryKey(options)
});
